<template>
<div>
<div v-if="isLoading" class="loading">Loading&#8230;</div>    
<div v-if="data_tran[0]">
 

<div class="columns is-gapless">
    <div class="column is-78 has-text-centered"></div>
    <div class="column is-4 has-text-centered">
        <button @click="save_transmission()" class="button is-fullwidth has-text-weight-bold has-background-success has-text-white" style="">
            <span class="icon has-text-left"><i class="fas fa-save"></i></span>     
        </button>
    </div>
</div>



<div class="columns box is-centered is-multiline" style="margin-top:-2em;">

<div class="column is-4">
<div class="columns is-gapless is-mobile is-multiline" style="margin-bottom:.5em;">
    <div class="column is-6 isLabel">Program</div>
    <div class="column is-12">
        <div class="select is-info is-fullwidth has-text-weight-bold">
            <select class="has-text-weight-bold" v-model="data_tran[0].prog_ID">
                    <option v-for="(choice,index) in data_programs" :key="index" :value="choice.prog_ID">{{ choice.prog_TITRE_F }} : {{choice.prog_CODEPLUS}}</option>
            </select>
        </div>                
    </div>


<div class="column is-6" style="margin-bottom:.5em;">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">Date de début</div>
    <div class="column is-12">
    <p class="control is-info has-icons-left">
        <flat-pickr 
            v-model="data_tran[0].student_CreateDate"
            class="input is-info is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtStart">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div></div>
 </div>


 <div class="column is-6" style="margin-bottom:.5em;">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 isLabel">Date de fin</div>
    <div class="column is-12">
    <p class="control is-info has-icons-left">
        <flat-pickr
            v-model="data_tran[0].student_EndDate"
            class="input is-info is-size-6 has-text-weight-bold has-text-centered"
            :config="config"
            name="dtEnd">
        </flat-pickr>  
    <span class="icon is-small is-left"><i class="fas fa-calendar-alt"></i></span></p>
 </div></div>
</div>

<div class="column is-6 has-text-left mt-4">
<div class="columns is-gapless is-multiline">
<div class="column is-12 has-text-left is-size-7"> NUM ADMISS. </div>
<div class="column is-12 has-text-left has-text-weight-bold"> {{data_tran[0].student_NumAdmission}} </div>
</div></div>


<div class="column is-3 has-text-centered">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-centered isLabel">Active&nbsp;&nbsp;</div>
    <div class="column is-12 has-text-centered">
    <div class="field is-fullwidth">
        <input v-model="data_tran[0].student_blnActive" id="switchActive" type="checkbox" name="switchActive" class="switch is-large is-fullwidth is-success">
        <label for="switchActive"></label>
    </div>
    </div>
</div>
</div>

<div class="column is-3">
<div class="columns is-gapless is-multiline">
    <div class="column is-12 has-text-centered isLabel">&nbsp;&nbsp;Diplômée</div>
    <div class="column is-12 has-text-centered">
    <div class="field is-fullwidth">
        <input v-model="data_tran[0].student_blnComplete" id="switchGrad" type="checkbox" name="switchGrad" class="switch is-large is-fullwidth is-success">
        <label for="switchGrad"></label>
    </div>
    </div>
</div>
</div>



</div></div>
<!-- END PROGRAM  -->








<div class="column is-4">
<div class="columns is-multiline is-gapless">

<div class="column is-4">
<div class="columns is-multiline is-gapless">
<div class="column is-12 isLabel">SEXE</div>   
    <div class="select is-info is-fullwidth has-text-centered has-text-weight-bold">
        <select v-model="data_tran[0].student_Sex">
            <option>M</option> <option>F</option><option>A</option>
        </select>
    </div>
</div></div>

<div class="column is-4">
<div class="columns is-multiline is-gapless">
<div class="column is-12 isLabel">BIRTHDAY</div>
<div class="column is-12"><flat-pickr placeholder="B-Day" v-model="data_tran[0].student_Birthday" class="input has-text-weight-bold has-text-centered  is-info" :config="config" name="dtBDay"></flat-pickr></div>
</div></div>

<div class="column is-4">
<div class="columns is-multiline is-gapless">
<div class="column is-12 isLabel">SOCIAL INSURANCE NUMBER</div>
<div class="column is-12"><input  v-model="data_tran[0].student_SIN" class="input is-fullwidth has-text-weight-bold  is-info" type="password" placeholder="N.A.S"></div>
</div></div>

<div class="column is-2 mt-2">Mère:</div><div class="column is-10"> <input  v-model="data_tran[0].student_parent_mom" class="input is-fullwidth has-text-weight-bold is-info" type="text" placeholder="...."></div>
<div class="column is-2 mt-2">Père:</div><div class="column is-10"> <input  v-model="data_tran[0].student_parent_dad" class="input is-fullwidth has-text-weight-bold is-info" type="text" placeholder="...."></div>




</div></div>
<!-- // END MIDDLE COLUMN  -->

<!-- PORTAL  -->
<div class="column is-4">
<div class="columns is-gapless box has-background-link-light is-multiline is-vcentered">

<div class="column is-12">
<div class="columns is-gapless is-multiline">
    <div class="column is-10 has-text-left has-text-weight-bold">Accès au portail</div>
    <div class="column is-2 has-text-left">
    <div class="field is-fullwidth">
        <input @change="change_portal_access()" v-model="data_tran[0].student_webNoNotes" id="switchPortal" type="checkbox" name="switchPortal" class="switch is-large is-fullwidth is-success">
        <label for="switchPortal"></label>
    </div>
    </div>
</div>
</div>

    <div class="column is-12 isLabel" style="margin-top:.5em;">Password</div>
    <div class="column is-6">
        <input disabled type="password"  v-model="data_tran[0].student_webPass" class="input is-fullwidth has-text-weight-bold has-text-centered has-background-white" placeholder="Web Pass ">
    </div>
    <div class="column is-1"></div>
    <div class="column is-5">
                <button @click="sms_pass_confirm()" title="SMS Password to Student" class="button is-fullwidth has-background-info has-text-white">
                    <span class="icon is-small has-text-left"><i class="fas fa-share-square"></i></span>     
                </button>
    </div>


</div></div>
<!-- // END RIGHT COLUMN  -->
<!-- END PROGRAM  -->
</div>
<!-- END TOP ROW  -->




<div class="columns is-multiline is-gapless has-text-weight-bold">

<div class="column is-6 has-background-light has-text-right">Lang Matrn&nbsp;&nbsp;</div>
<div class="column is-4 select is-fullwidth is-dark"><select v-model="data_tran[0].matLang" class=" has-text-dark "><option  v-for="(data,index) in langmat" :key="index"  :value="data.val">{{data.val}}</option></select></div>


    <div class="column is-2">
        <button @click="load_default_confirm()" class="button is-fullwidth has-background-info has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-plus"></i></span>     
        </button> 
    </div>
    <!-- <div class="column is-1">
        <button @click="save_transmission()" class="button is-fullwidth has-background-success has-text-white">
            <span class="icon is-small has-text-left"><i class="fas fa-save"></i></span>     
        </button> 
    </div> -->


<div class="column is-6 has-background-light has-text-right">Lang Usage&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].useLang" class=" has-text-dark "><option  v-for="(data,index) in langmat" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Statut légal au Canada&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].status" class=" has-text-dark "><option  v-for="(data,index) in statlegal" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].status_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartStatus"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].status_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartStatus"></flat-pickr></div>


<div class="column is-6 has-background-light has-text-right">Code de pays de citoyenneté&nbsp;&nbsp;</div>
<div class="column is-6 select is-dark is-fullwidth"><select v-model="data_tran[0].codePAYS" class=" has-text-dark "><option  v-for="(data,index) in country" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Code de province ou territoire du Canada&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].codePROVINCE" class=" has-text-dark "><option  v-for="(data,index) in province" :key="index"  :value="data.val">{{data.val}}</option></select></div>


<div class="column is-6 has-background-light has-text-right">Critére pour établir le statut du Québec&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].criteria" class=" has-text-dark "><option  v-for="(data,index) in criteria" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].criteria_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartCrit"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].criteria_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartCrit"></flat-pickr></div>

<div class="column is-6 has-background-light has-text-right">Autorisation pour étudier au Canada&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].autoCAN" class=" has-text-dark "><option  v-for="(data,index) in autoCan" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].autoCAN_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartCan"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].autoCAN_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartCan"></flat-pickr></div>

<div class="column is-6 has-background-light has-text-right">Autorisation pour étudier au Québec&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].autoQC" class=" has-text-dark "><option  v-for="(data,index) in autoQc" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].autoQC_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartQc"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].autoQC_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartQc"></flat-pickr></div>

<div class="column is-6 has-background-light has-text-right">Entente sur la mobilité&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].mobilite" class=" has-text-dark "><option  v-for="(data,index) in mobile" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].mobilite_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartM"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].mobilite_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartM"></flat-pickr></div>

<div class="column is-6 has-background-light has-text-right">Condition particuliére d'exemption de montant&nbsp;&nbsp;</div>
<div class="column is-2 select is-fullwidth is-dark"><select v-model="data_tran[0].exemption" class=" has-text-dark "><option  v-for="(data,index) in conditionparticular" :key="index"  :value="data.val">{{data.val}}</option></select></div>
<div class="column is-2"><flat-pickr placeholder="entrée" v-model="data_tran[0].exemption_entDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartPar"></flat-pickr></div>
<div class="column is-2"><flat-pickr placeholder="expiration" v-model="data_tran[0].exemption_expDATE" class="input has-text-weight-bold has-text-centered" :config="config" name="dtStartPar"></flat-pickr></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de détention des documents officiels&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].document" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Service d'enseignement&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].service" class=" has-text-dark "><option  v-for="(data,index) in service" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Type de fréquentation scolaire&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].typeScolaire" class=" has-text-dark "><option  v-for="(data,index) in type" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Conditions d'admission au programme&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].conditionProgram" class=" has-text-dark "><option  v-for="(data,index) in conditionprogram" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Condition spécifique d'admission à l'AEC&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].conditionAdmission" class=" has-text-dark "><option  v-for="(data,index) in conditionadmission" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Situation d'élève à temps partiel réputé temps plein&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].situation" class=" has-text-dark "><option  v-for="(data,index) in situation" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur d'ATE&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorATE" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de cheminement DEC-BACC&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorBACC" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de programme référé par Emploi-Québec&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorEMPLOY" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de programme référé par un ordre professionnel&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorPRO" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur milieu carcéral&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorCARC" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de groupe de religion spécifique&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorRELIGION" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur de voyage autour du monde&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].indicatorVOYAGE" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Situation spécifique d'élève&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].situationSpecific" class=" has-text-dark "><option  v-for="(data,index) in situationspecific" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Type de composante de financement du cours&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].typeFinance" class=" has-text-dark "><option  v-for="(data,index) in typefinance" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Type de reconnaissance d'acquis de formation&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].typeFormation" class=" has-text-dark "><option  v-for="(data,index) in typeformation" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Mode d'enseignement à distance&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].mode" class=" has-text-dark "><option  v-for="(data,index) in mode" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Indicateur d'intention de substitution&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].sub" class=" has-text-dark "><option  v-for="(data,index) in indicator" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Situation d'études dans un organisme partenaire&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].situationOrg" class=" has-text-dark "><option  v-for="(data,index) in situationorg" :key="index"  :value="data.val">{{data.val}}</option></select></div>

<div class="column is-6 has-background-light has-text-right">Source de financement collégiale&nbsp;&nbsp;</div>
<div class="column is-6 select is-fullwidth is-dark"><select v-model="data_tran[0].sourceFinance" class=" has-text-dark "><option  v-for="(data,index) in sourcefinance" :key="index"  :value="data.val">{{data.val}}</option></select></div>


</div>

<!-- END CONTAINER  -->

    
</div></div>
</template>
    
    <script>
    import axios from 'axios';
    import moment from 'moment';

    export default {
        props: [ 'studentID', 'programs'],

        data() {
            return {

isLoading : true ,
isReady : false , // AFTER LOAD !


data_tran:[],
data_programs:this.programs,

isDirty : false, // FOR DETECTING CHANGES


show_criteria:false,

config: { // FLATPICKER
    altFormat: "M j, Y",
    altInput: true
},



                langmat:[] , // [{"val":"FR : Français"},{"val":"AN : Anglais"},{"val":"AT : Autochtone"},{"val":"AU : Autre que AN, FR"},{"val":"AV : Autre que AN, AT et FR"},{"val":"ND : Non déclarée"}],
                langusage:[] , // [ {"val":"FR : Français"},{"val":"AN : Anglais"},{"val":"AT : Autochtone"},{"val":"AU : Autre que AN, FR"},{"val":"AV : Autre que AN, AT et FR"},{"val":"ND : Non déclarée"}],
                statlegal:[] , // [ {"val":"CC : Citoyen canadien"},{"val":"AU : Autre statut légal au Canada"},{"val":"IN : Indien"},{"val":"ND : Non disponible"},{"val":"RE :  Réfugié reconnu"},{"val":"RP :  Résident permanent"},{"val":"RT :  Résident temporaire"},{"val":"SO : Sans objet"}],
                criteria:[] , // 
                province:[] ,
                autoCan:[] ,
                autoQc:[] ,
                mobile:[] ,
                conditionparticular:[] ,
                indicator:[] ,
                service:[] ,
                type:[] ,
                conditionprogram:[] ,
                conditionadmission:[] ,
                situation:[] ,
                situationspecific:[] ,
                typefinance:[] ,
                typeformation:[] ,
                mode:[] ,
                situationorg:[] ,
                sourcefinance:[] ,
                typeengage:[] ,
                territory:[] ,
                country:[] ,

            }
        },

created() {

this.langmat=[{"val":"FR = Français"},{"val":"AN = Anglais"},{"val":"AT = Autochtone"},{"val":"AU = Autre que AN, FR"},{"val":"AV = Autre que AN, AT et FR"},{"val":"ND = Non déclarée"}]
this.statlegal=[ {"val":"CC = Citoyen canadien"},{"val":"AU = Autre statut légal au Canada"},{"val":"IN = Indien"},{"val":"ND = Non disponible"},{"val":"RE =  Réfugié reconnu"},{"val":"RP =  Résident permanent"},{"val":"RT =  Résident temporaire"},{"val":"SO = Sans objet"}]
this.criteria=[ {"val":"01 = Né au Québec"},{"val":"NR = Non requis"},{"val":"SO = Sans objet"},{"val":"ND = Non disponible"},{"val":"00 = Aucun critère"},{"val":"02 = Adopté"},{"val":"03 = Parents décédés"},{"val":"04 = Titulaire d'un CSQ"},{"val":"05 = Attestation d'études"},{"val":"05 = Titulaire DES et DEC"},{"val":"40 = Autre org. collég. - permanent"},{"val":"41 = Autre org. univer. - permanent"},{"val":"52 = Selon l'AFE"},{"val":"53 = Autochtone"},{"val":"61 = Parents résidents du Québec"},{"val":"62 = Parents ont quitté le Québec"},{"val":"63 = Périodes d'études consécutives"},{"val":"64 = Période trois mois"},{"val":"65 = Conjoint légal ou de fait"},{"val":"68 = Foyer d'accueil au Québec"},{"val":"69 = Maintien de statut"},{"val":"82 = Autre org. collég. -provisoire"},{"val":"83 = Autre org. univer. -provisoire"},{"val":"85 = Cas spéciaux"},{"val":"95 = Système GDEU"},{"val":"96 = Système SIGDEC"},{"val":"99 = Attestation antérieure"}]
this.province = [ {"val":"016 = Québec"},{"val":"002 = Alberta"},{"val":"004 = Colombie-Britannique"},{"val":"006 = Île-du-Prince-Édouard"},{"val":"008 = Manitoba"},{"val":"010 = Nouveau-Brunswick"},{"val":"012 = Nouvelle-Écosse"},{"val":"013 = Nunavut"},{"val":"014 = Ontario"},{"val":"018 = Saskatchewan"},{"val":"020 = Terre-Neuve-et-Labrador"},{"val":"020 = Terre-Neuve"},{"val":"022 = Territoires du Nord-Ouest"},{"val":"024 = Territoire du Yukon"}]
this.autoCan = [ {"val":"SO = Sans objet"},{"val":"DG =Déclaration de garde"},{"val":"DI = Représ. étranger"},{"val":"FA = Forces armées"},{"val":"ND = Non disponible"},{"val":"NR = Non requis"},{"val":"PE = Permis d'études"},{"val":"PT = Permis de travail"}]
this.autoQc = [ {"val":"SO = Sans objet"},{"val":"BRS = Boursier"},{"val":"CAQ = Détention d'un CAQ - études"},{"val":"CAT = Détention d'un CAQ - travail"},{"val":"CSQ = Détention d'un CSQ"},{"val":"ECD = Courte durée"},{"val":"EDA = Demandeur d'asile"},{"val":"EPE = Enfant mineur permis"},{"val":"EPS =	Âge préscolaire"},{"val":"LPE = Lettre Qc - étranger"},{"val":"ND = Non disponible"},{"val":"PCA = Assistance"}]
this.mobile = [ {"val":"SO = Sans objet"},{"val":"00 = Aucune entente"},{"val":"40 = Entente interprovinciale"},{"val":"45 = Entente programme d’échange"},{"val":"51 = Entente intergouvernementale"},{"val":"10 = Entente CREPUQ parité Qc HQ"},{"val":"11 = Entente interun. parité Qc HQ"},{"val":"12 = Entente interun. s-parité Qc HQ"},{"val":"20 = Entente CREPUQ parité HQ Qc"},{"val":"21 = Entente interun. parité HQ Qc"},{"val":"22 = Entente interun. s-parité HQ Qc	"},{"val":"30 = Convention-cadre québécois Qc"},{"val":"31 = Convention-cadre québécois France"},{"val":"32 = Entente convention-cadre français Qc"},{"val":"33 = Convention-cadre français France"},{"val":"34 = Convention-cadre français QC s-entente"},{"val":"50 = Boursier du Québec"},{"val":"52 = Entente quota d’exemptions"},{"val":"60 = Entente situation d’accueil	"}]
this.conditionparticular = [ {"val":"CCA = Citoyenneté can. et autre"},{"val":"CCF = Citoyenneté can. et fran"},{"val":"DAS = Demandeur d'asil"},{"val":"DRP = Demande résidence permanente"},{"val":"LPO = Lettre  Qc - ONG"},{"val":"MIN = Autorisation except. min."},{"val":"ND = Non disponible"},{"val":"PER = Personnel organisme scolaire"},{"val":"PST = Permis de séjour temporaire"},{"val":"PTT = Permis de travail temporaire"},{"val":"SO = Sans objet"},{"val":"X = Aucune condition"}]
this.indicator = [ {"val":"O = Oui"},{"val":"N = Non"}]
this.service = [ {"val":"O = Formation ordinaire"},{"val":"C = Formation continue"}]
this.type = [ {"val":"TPL = Temps plein"},{"val":"TPA = Temps partiel"}]
this.conditionprogram = [ {"val":"CAS  = Conditions satisfaites"},{"val":"EQU = Équivalence hors Québec"},{"val":"DEP  = Autorisation DEP-DEC"},{"val":"SUF = Conditions jugées suffisantes"}]
this.conditionadmission = [ {"val":"E = Entente collège employeur"},{"val":"I = Interruption d'études"},{"val":"P = Études postsecondaires"}]
this.situation = [ {"val":"SO = Sans objet"},{"val":"CC = Contrainte d'offre de cours"},{"val":"FE = Fin d’études DEC ou AEC"},{"val":"DF = Déficience fonctionnelle majeure et à temps partiel"}]
this.situationspecific = [ {"val":"AUT = Projet pour autochtone"},{"val":"HAN = Service personne handicapée"},{"val":"URE = Situation d’unités retenues"},{"val":" "},{"val":""}]
this.typefinance =[ {"val":" SO = Sans objet"},{"val":"CE = Continuité d'études"},{"val":"GC = Form. gén. communeFormation générale commune"},{"val":"GM = Form. gén. compl.Formation générale complémentaire"},{"val":"GP = Form. gén. propreFormation générale propre"},{"val":"HP = Hors programmeAutre formation de nature 'hors-programme"},{"val":"MN = Form. mise à niv.Formation de mise à niveau"},{"val":"PU = Préal. universitaireFormation préalable aux études universitaires au-delà de la formation spécifique"},{"val":"SP = Form. spécifiqueFormation spécifique"},{"val":"NA = Sans objet (Ne s'applique pas) : La session concernée est antérieure à la session d'automne 95. Situation de commandite, aux "},{"val":"IC = transmises par l'établissement commandité."},{"val":"GC = Formation générale communeFormation générale commune"},{"val":"GP= Formation générale propre"},{"val":"GM = Formation générale complémentaireFormation générale complémentaire"},{"val":"SP = Formation spécifiqueFormation spécifique"},{"val":"MN= Formation de mise à niveauFormation de mise à niveau"},{"val":"PU = Préalable universitaireFormation préalable aux études universitaires au-delà de a formation spécifique"},{"val":"HP = Hors programmeAutre formation de nature hors-programme"}]
this.typeformation = [ {"val":"SO = Sans objet"},{"val":"EE = Extra-scol. éval."},{"val":"FM = Formation manquante"},{"val":"RS = Récupération de cours"},{"val":""}]
this.mode = [ {"val":"SO = Sans objet"},{"val":"TL = Télématique"},{"val":"TV = Télévision"},{"val":"AS = Asynchrone"},{"val":"CD = CD-ROM"},{"val":"CO = Correspondance"},{"val":"SY = Synchrone"}]
this.situationorg = [ {"val":"SO = Sans objet"},{"val":"CS = Cours à suivre"},{"val":"CR = Cours à remplacer"}]
this.sourcefinance = [ {"val":"00 = Sans financement"},{"val":"10 = Financé normalement par  MELS"},{"val":"11 = Financé via priorités MELS"},{"val":"12 = Financé via Env. reg. EQ"},{"val":"15 = Danse-ballet financé MELS"},{"val":"16 = Métier d'arts financé  MELS"},{"val":"30 = EQ- Temps complet"},{"val":"31 = EQ-Temps partiel"},{"val":"32 = EQ- Place- Élève"},{"val":"40 = Autre ministère"},{"val":"50 = Assumé par l'élève"},{"val":"90 = Entreprise privée"}]
this.typeengage = [ {"val":""},{"val":"ART = Culturel-artistique"},{"val":"ENT = Entreprenariat"},{"val":"POL = Politique"},{"val":"SCI = Scientifique"},{"val":"SCO = Scolaire"},{"val":"SOC = Social-commun."},{"val":"SPO = Sportif"}]
this.territory = [ {"val":"QC = Québec"},{"val":"HQ = Hors Québec"}]
this.country = [ {"val":"001 = Canada"},{"val":"050 = Etats-Unis"},{"val":""}]





}, // END CREATED



watch: { // CHECK FOR CHANGE !!
    data_tran: {
        handler: function() {
           if (this.isReady) {this.$emit("emit_somethingChanged")}
        },
        deep: true
    }
},


mounted() {
// GET THE DATA
this.load_data()
},


methods : {

change_portal_access:function() {
    if(this.data_tran[0].student_webNoNotes==true) {
        if (!this.data_tran[0].student_webPass) {this.data_tran[0].student_webPass = this.generatePass()}
    }
},
generatePass:function() {
    return 'xxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
},



load_data:function() {
    this.isLoading=true;
    var query = "SELECT student_Sex, student_NumAdmission,student_parent_mom,student_parent_dad, student_TelOther, MyMEQ_STUDENT.student_SIN,MyMEQ_STUDENT.student_Birthday,student_webPass,prog_ID,student_CreateDate,student_EndDate,student_blnActive, student_blnComplete,student_webNoNotes, myMEQ_STUDENT_TRANSMISSION.* FROM MyMEQ_STUDENT INNER JOIN myMEQ_STUDENT_TRANSMISSION ON MyMEQ_STUDENT.student_ID = myMEQ_STUDENT_TRANSMISSION.student_ID WHERE MyMEQ_STUDENT.student_ID = " + this.studentID
console.log(query)
    axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
    .then(res => {     
        this.data_tran = res.data
        setTimeout(() => { this.isReady=true; }, 500);
        this.isLoading=false;
    }) 
},


sms_pass_confirm:function() {

        this.$snotify.confirm('SMS Password to Student? ' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
        position: "centerCenter",
            buttons: [
                {text: 'Yes', action: (toast) => this.sms_pass_do(toast)},
                {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
            ]
        });

},
sms_pass_do:function(toast) {
    this.$snotify.remove(toast.id)

var cell = this.data_tran[0].student_TelOther.replace(/\D/g,'');

axios.post(this.$url+'/sms_send?msg=Votre Password : ' + this.data_tran[0].student_webPass +  '&to='+cell)
.then(res => { this.$snotify.success('SENT!!' , {timeout: 2000,showProgressBar: true,closeOnClick: true,pauseOnHover: true,position: "rightBottom",}); })




},



load_default_confirm:function() {

        this.$snotify.confirm('Insert Default Transmission Data? ' , { timeout: 5000, showProgressBar: true, closeOnClick: false, pauseOnHover: false,
        position: "centerCenter",
            buttons: [
                {text: 'Yes', action: (toast) => this.load_default_save(toast)},
                {text: 'No', action: (toast) => this.$snotify.remove(toast.id)},
            ]
        });

},
load_default_save:function(toast) {
    this.$snotify.remove(toast.id)

var query = "UPDATE myMEQ_STUDENT_TRANSMISSION SET  status = 'CC = Citoyen canadien', status_entDATE = " + moment().format('YYYY-MM-DD') + ", status_expDATE = NULL, codePAYS = '001 = Canada', codePROVINCE = '016 = Québec', criteria = '01 = Né au Québec', criteria_entDATE = NULL, criteria_expDATE = NULL, autoCAN = 'SO = Sans objet', autoCAN_entDATE = NULL, autoCAN_expDATE = NULL, autoQC = 'SO = Sans objet', autoQC_entDATE = NULL, autoQC_expDATE = NULL, mobilite = '00 = Aucune entente', mobilite_entDATE = NULL, mobilite_expDATE = NULL, exemption = 'X = Aucune condition', exemption_entDATE = NULL, exemption_expDATE = NULL, document = 'O = Oui', reference = '', declarationDATE = NULL, service = 'C = Formation continue', typeScolaire = 'TPL = Temps plein', conditionProgram = 'SUF = Conditions jugées suffisantes', conditionAdmission = 'I = Interruption d''études', situation = 'SO = Sans objet', indicatorATE = 'N = Non', indicatorBACC = 'N = Non', indicatorEMPLOY = 'N = Non', indicatorPRO = 'N = Non', indicatorCARC = 'N = Non', indicatorRELIGION = 'N = Non', indicatorVOYAGE = 'N = Non', situationSpecific = ' ', typeFinance = 'SP = Form. spécifiqueFormation spécifique', typeFormation = 'SO = Sans objet', mode = 'SO = Sans objet', sub = 'N = Non', situationOrg = 'SO = Sans objet', codePartner = '', coursePartner = '', sourceFinance = '', typeEngage = '', territory = '', codeCollegial = '', annee     = '', groupMinistry  = '', sessionDATE = NULL, codePassion = '' " 
query += " WHERE ( student_ID =" + this.studentID + ")"
console.log(query)
axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true});
    this.load_data() // RE-LOAD THE DATA
});


},



save_transmission:function() {


var query = "UPDATE myMEQ_STUDENT_TRANSMISSION SET " 
query += " matLang = '" + this.chk_val(this.data_tran[0].matLang)
query += "', useLang = '" + this.chk_val(this.data_tran[0].useLang)
query += "', status = '" + this.chk_val(this.data_tran[0].status)
query += "', status_entDATE = " + this.chk_date(this.data_tran[0].status_entDATE)
query += ", status_expDATE = " + this.chk_date(this.data_tran[0].status_expDATE)
query += ", codePAYS = '" + this.chk_val(this.data_tran[0].codePAYS)
query += "', codePROVINCE = '" + this.chk_val(this.data_tran[0].codePROVINCE)
query += "', criteria = '" + this.chk_val(this.data_tran[0].criteria)
query += "', criteria_entDATE = " + this.chk_date(this.data_tran[0].criteria_entDATE)
query += ", criteria_expDATE = " + this.chk_date(this.data_tran[0].criteria_expDATE)
query += ", autoCAN = '" + this.chk_val(this.data_tran[0].autoCAN)
query += "', autoCAN_entDATE = " + this.chk_date(this.data_tran[0].autoCAN_entDATE)
query += ", autoCAN_expDATE = " + this.chk_date(this.data_tran[0].autoCAN_expDATE)
query += ", autoQC = '" + this.chk_val(this.data_tran[0].autoQC)
query += "', autoQC_entDATE = " + this.chk_date(this.data_tran[0].autoQC_entDATE)
query += ", autoQC_expDATE = " + this.chk_date(this.data_tran[0].mobilite)
query += ", mobilite = '" + this.chk_val(this.data_tran[0].mobilite)
query += "', mobilite_entDATE = " + this.chk_date(this.data_tran[0].mobilite_entDATE)
query += ", mobilite_expDATE = " + this.chk_date(this.data_tran[0].mobilite_expDATE)
query += ", exemption = '" + this.chk_val(this.data_tran[0].exemption)
query += "', exemption_entDATE = " + this.chk_date(this.data_tran[0].exemption_entDATE)
query += ", exemption_expDATE = " + this.chk_date(this.data_tran[0].exemption_expDATE)
query += ", document = '" + this.chk_val(this.data_tran[0].document)
query += "', reference = '" + this.chk_val(this.data_tran[0].reference)
query += "', declarationDATE = " + this.chk_date(this.data_tran[0].declarationDATE)
query += ", service = '" + this.chk_val(this.data_tran[0].service)
query += "', typeScolaire = '" + this.chk_val(this.data_tran[0].typeScolaire)
query += "', conditionProgram = '" + this.chk_val(this.data_tran[0].conditionProgram)
query += "', conditionAdmission = '" + this.chk_val(this.data_tran[0].conditionAdmission)
query += "', situation = '" + this.chk_val(this.data_tran[0].situation)
query += "', indicatorATE = '" + this.chk_val(this.data_tran[0].indicatorATE)
query += "', indicatorBACC = '" + this.chk_val(this.data_tran[0].indicatorBACC)
query += "', indicatorEMPLOY = '" + this.chk_val(this.data_tran[0].indicatorEMPLOY)
query += "', indicatorPRO = '" + this.chk_val(this.data_tran[0].indicatorPRO)
query += "', indicatorCARC = '" + this.chk_val(this.data_tran[0].indicatorCARC)
query += "', indicatorRELIGION = '" + this.chk_val(this.data_tran[0].indicatorRELIGION)
query += "', indicatorVOYAGE = '" + this.chk_val(this.data_tran[0].indicatorVOYAGE)
query += "', situationSpecific = '" + this.chk_val(this.data_tran[0].situationSpecific)
query += "', typeFinance = '" + this.chk_val(this.data_tran[0].typeFinance)
query += "', typeFormation = '" + this.chk_val(this.data_tran[0].typeFormation)
query += "', mode = '" + this.chk_val(this.data_tran[0].mode)
query += "', sub = '" + this.chk_val(this.data_tran[0].sub)
query += "', situationOrg = '" + this.chk_val(this.data_tran[0].situationOrg)
query += "', codePartner = '" + this.chk_val(this.data_tran[0].codePartner)
query += "', coursePartner = '" + this.chk_val(this.data_tran[0].coursePartner)
query += "', sourceFinance = '" + this.chk_val(this.data_tran[0].sourceFinance)
query += "', typeEngage = '" + this.chk_val(this.data_tran[0].typeEngage)
query += "', territory = '" + this.chk_val(this.data_tran[0].territory)
query += "', codeCollegial = '" + this.chk_val(this.data_tran[0].codeCollegial)
query += "', annee	 = '" + this.chk_val(this.data_tran[0].annee)
query += "', groupMinistry	 = '" + this.chk_val(this.data_tran[0].groupMinistry)
query += "', sessionDATE = " + this.chk_date(this.data_tran[0].sessionDATE)
query += ", codePassion = '" + this.chk_val(this.data_tran[0].codePassion)
query += "' WHERE ( student_ID =" + this.studentID + ")"

// SAVE STUDENT INFO
query += " ; UPDATE myMEQ_STUDENT SET "
query += " student_Birthday = " + this.chk_date(this.data_tran[0].student_Birthday) + ", "
query += "student_SIN = '" + this.data_tran[0].student_SIN + "', "
query += "prog_ID = " + this.data_tran[0].prog_ID + ", "
query += "student_CreateDate = " + this.chk_date(this.data_tran[0].student_CreateDate) + ", "
query += "student_EndDate = " + this.chk_date(this.data_tran[0].student_EndDate) + ", "
query += "student_blnActive = " + +this.data_tran[0].student_blnActive + ", "
query += "student_blnComplete = " + +this.data_tran[0].student_blnComplete + ", "
query += "student_webNoNotes = " + +this.data_tran[0].student_webNoNotes + ", "
query += "student_webPass = '" + this.chk_val(this.data_tran[0].student_webPass) + "', "
query += "student_parent_mom = '" + this.chk_val(this.data_tran[0].student_parent_mom) + "', "
query += "student_parent_dad = '" + this.chk_val(this.data_tran[0].student_parent_dad) + "', "
query += "student_Sex = '" + this.chk_val(this.data_tran[0].student_Sex) + "' "
query += " WHERE ( student_ID =" + this.studentID + ")"

console.log(query)

axios.get(this.$url+sessionStorage.getItem('url_query')+'?query=' + encodeURIComponent(query))
.then(res => { 
    this.$snotify.success('Saved !!', {timeout: 2000,showProgressBar: true,closeOnClick: false,pauseOnHover: true});
    this.$emit("emit_somethingSaved")
});


}, // END SAVE !


chk_val:function(val) {
// CHECK FOR NULLS ON SAVE
    if (!val) {return ''} 
    else {return val.replace(/'/g,"''")}
},
chk_date(val){
    if (moment(val).isValid()) { return "'" +  moment(val).format('YYYY-MM-DD') + "'" } else {return null}
},


},




    }
    </script>
    
    <style>
    
    </style>